import { atomWithStorage, createJSONStorage } from "jotai/utils";
import { atomPersistor } from "./atomPersistor";

export const createPersistedAtom = <Value>(key: string, defaultValue: Value) =>
  atomWithStorage(
    key,
    defaultValue,
    createJSONStorage(() => atomPersistor)
  );
